// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AlternateCardType } from './alternateCardType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ExtEnrollmentAlternateCardId {
    'alternateCardNumber'?: string;
    'cardAlternateIdType'?: AlternateCardType;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ExtEnrollmentAlternateCardId>> = [
        {
            "name":     "alternateCardNumber",
            "baseName": "alternateCardNumber",
            "type":     "string"
        },
        {
            "name":     "cardAlternateIdType",
            "baseName": "cardAlternateIdType",
            "type":     "AlternateCardType"
        },
    ];

    static getAttributeTypeMap() {
        return ExtEnrollmentAlternateCardId.attributeTypeMap;
    }
}
